<template>
  <main id="main-layout">
    <div class="login-background">
      <div class="login-card">
        <div class="header">
          <div class="title-bar">
            <h4>Signin to access snapp.it</h4>
          </div>
        </div>
        <div class="contents">
          <form @submit.prevent="signIn" class="input-area">
            <input
              class="inputField"
              type="email"
              placeholder="Email"
              v-model="form.email"
            />
            <input
              class="inputField"
              type="password"
              placeholder="Password"
              v-model="form.password"
            />
            <button type="submit">Sign In</button>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import { mapActions } from "vuex";
  export default {
    data() {
      return {
        form: {
          email: "",
          password: "",
        },
      };
    },
    methods: {
      ...mapActions("Auth", ["signInAction"]),
      async signIn() {
        await this.signInAction(this.form);
      },
    },
  };
</script>

<style lang="scss" scoped>
  main, #main-layout {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: var(--color-secondary-light);
    position: relative;
  }

  .login-background {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: var(--popup-background);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;

  }

  .login-card {
    display: flex;
    flex-direction: column;
    width: 90%;
    max-width: 450px;
    border-radius: 5px;
    background: var(--color-secondary);
    margin-top: 150px;

    .header {
      display: flex;
      flex-direction: column;

      .title-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--border-color);
        padding: 10px 15px;

        h4 {
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 0.1rem;
        }
      }
    }

    .contents {
      display: flex;
      flex-direction: column;
      padding: 5px 15px;

      form.input-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin: 30px;
        row-gap: 30px;

        input {
          width: 100%;
          flex: 1;
          background: transparent;
          border: 0;
          padding: 15px;
          font-size: 1.2rem;
          color: var(--font-color);
          border-radius: 0;
          border-bottom: 2px solid var(--border-color);
          outline: none;
          transition: 0.3s all ease-in-out;
          &:focus {
            border: none;
            border-bottom: 2px solid var(--color-accent);
          }
        }

        button {
          background: var(--color-input-background);
          border: 0;
          outline: none;
          display: flex;
          align-items: center;
          padding: 5px 10px;
          border-radius: 3px;
          color: var(--font-color);
          font-size: 18px;
          margin-top: 10px;

          &:hover {
            cursor: pointer;
            color: var(--color-primary);
          }
        }
      }
    }
  }
</style>
